module.exports = __webpack_public_path__ + "static/contact_enquiry-f0e6cfbe80a3fde4077a82a760e22b52.svg";